<template>
    <div class="page bg-gray page-flex">
        <appStatus :statusHeight="statusHeight"></appStatus>
        <div class="page-input-title" :style="{top:statusHeight+'rem'}">
            <div class="alifont icon-back left-icon click" @click="back"></div>
            <input type="search" @keyup.13="handleQuery" class="center-input fs-28" placeholder="搜索订单号/手机号" v-model="pageInfo.keywords">
            <div class="right fs-28 color-333 click" @click="handleQuery">
                搜索
            </div>
        </div>
        <div class="page-state">
            <van-tabs v-model="tabActive" swipeable :swipe-threshold="5" :line-width="'.6rem'" @click="tabClick">
                <van-tab :title="item.title" :name="item.value" v-for="(item,$index) in tabList" :key="$index"></van-tab>
            </van-tabs>
        </div>
        <div class="org-filter-bar bg-fff">
            <div class="org-filter-trigger click" @click="openOrgPicker">
                <span class="org-filter-label">小区</span>
                <span class="org-filter-value ellipsis">{{ orgDisplayName }}</span>
                <van-icon name="arrow-down" class="org-filter-icon" />
            </div>
        </div>
        <div class="flex1 posi-rel">
            <scroller ref="scroller" :on-refresh="loadNewData" :on-infinite="loadMore">
                <ul class="">
                    <li v-for="(item,$index) in data" :key="$index" class="order-item" @click="getScrollerPosition();$router.push({name:'orderDetail',query:{orderId: item.orderId,isManager:isManager}})">
                        <div class="bd-bot" v-if="item.orderStatus == 2">
                            <div class="flex-center address-box">
                                <div class="alifont icon-dizhi"></div>
                                <div class="flex1">
                                    <div class="fs-28 color-333">{{item.userAddress}}</div>
                                    <div class="flex fs-28 color-999 mt-5">
                                        <div class="mr-30">{{item.userName}}</div>
                                        <div>{{item.userMobile}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="text-center fs-32 color-main pb-25 click" @click.stop="" v-clipboard:copy="item.userName +','+item.userMobile + ',' + item.userAddress" v-clipboard:success="onCopySuccess" v-clipboard:error="onCopyError">
                                复制发货信息
                            </div>
                        </div>
                        <div class="flex-between fs-28 bd-bot pd-250">
                            <div class="color-333">
                                <div>订单编号：{{ item.orderNo }}</div>
                                <div class="color-999 fs-24 margin-top-sm" v-if="item.orgName">小区：{{ item.orgName }}</div>
                                <!-- 时间显示在下一行 -->
                                <div class="color-999 fs-24 margin-top-sm">{{ item.payTime }}</div>
                            </div>

                            <div v-for="dictItem in dicts['orderStatus']" :key="dictItem.codeid" v-if="String(item.orderStatus) == dictItem.code">
                                <span :class="dictItem.code == 1? 'color-main':(dictItem.code == 9 || dictItem.code == 0) ? 'color-red':'color-org'">{{ dictItem.codename }}</span>
                            </div>
                        </div>

                        <div class="product-list bd-bot">
                            <div class="product-item flex pd-250" v-for="(prod,prodIndex) in item.productList" :key="prodIndex">
                                <div class="product-img"><img :src="prod.imgPathView" alt=""></div>
                                <div class="product-info flex1 ofh">
                                    <div class="fs-28 color-000 name">{{prod.productName}}</div>
                                    <div class="mt-15 fs-28 color-999">规格：{{prod.specName}}</div>
                                    <div class="flex-between fs-28 color-999">
                                        <div>销售价：¥{{prod.salePrice}}</div>
                                        <div>x{{prod.productQty}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="pd-250 bd-bot flex-between flex-center fs-28">
                            <div>
                                <span class="color-999">顾客：</span>
                                <span class="color-333">{{item.nickname}}</span>
                            </div>
                            <div>
                                <span class="color-999">合计：</span>
                                <span class="fs-24 color-red">¥</span>
                                <span class="fs-36 color-red">{{item.receivable}}</span>
                            </div>
                        </div>
                        <div class="pd-250 bd-bot flex-between flex-center fs-28" v-if="item.remark && item.remark != ''">
                            <div>
                                <span class="color-999">备注：</span>
                                <span class="color-333">{{item.remark}}</span>
                            </div>
                        </div>
                        <div class="btn-group" v-if="item.orderStatus == 2 && isManager !='1'">
<!--                            <div class="btn click" @click.stop="refundFun(item)">退款</div>-->
                            <div class="btn click active" @click.stop="getScrollerPosition();$router.push({name:'sendOrder',query:{orderId: item.orderId}})">发货</div>
                        </div>
                        <div class="btn-group" v-if="item.orderStatus == 3 && isManager !='1'">
                            <div class="btn click active" @click.stop="deliverOrder(item)">已送达</div>
                        </div>

                    </li>
                </ul>
            </scroller>
        </div>

        <van-popup v-model="showOrgPicker" position="bottom" round :style="{ height: '60%' }">
            <div class="org-picker-popup">
                <van-search
                    v-model="orgSearchKey"
                    placeholder="搜索小区名称"
                    shape="round"
                />
                <div class="org-picker-list">
                    <div
                        class="org-picker-item click"
                        :class="{ active: !orgInf.orgId }"
                        @click="onSelectOrg(null)"
                    >
                        全部小区
                    </div>
                    <div
                        v-for="item in filteredOrgList"
                        :key="item.orgId"
                        class="org-picker-item click"
                        :class="{ active: orgInf.orgId === item.orgId }"
                        @click="onSelectOrg(item)"
                    >
                        {{ item.orgName }}
                    </div>
                    <div
                        v-if="orgSearchKey && filteredOrgList.length === 0"
                        class="org-picker-empty"
                    >
                        暂无匹配小区
                    </div>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>
    import initData from "@/mixins/initData"
    import routerBack from "@/mixins/routerBack"
    import initDict from '@/mixins/initDict'
    import appStatus from "@/components/appStatus/index"
    import getAppStatusHeight from "@/mixins/getAppStatusHeight";
    import {refundOrder, batchUpdateOrderStatus} from "@/api/order"
    import { getOrgListByPassId } from "@/api/scm/planShopApply";
    export default {
        name: "orderList",
        mixins: [initData,routerBack,initDict,getAppStatusHeight],
        components:{appStatus},
        data(){
            return {
                tabList:[
                    {title:'全部',value:'1'},
                    {title:'待使用',value:'2'},
                    {title:'待发货',value:'3'},
                    {title:'待收货',value:'4'},
                    {title:'已完成',value:'5'},
                ],
                tabActive: '1',
                orderStatus: null,
                isManager:'0',
                showOrgPicker: false,
                orgSearchKey: '',
                orgColumns: [],
                orgInf: { orgId: '', orgName: '' },

                shopId: this.$store.state.user.shopId
            }
        },
        computed: {
            orgDisplayName() {
                return this.orgInf.orgName || '全部小区';
            },
            filteredOrgList() {
                const key = this.orgSearchKey.trim();
                if (!key) {
                    return this.orgColumns;
                }
                return this.orgColumns.filter(
                    (item) => item.orgName && item.orgName.includes(key)
                );
            },
        },
        created(){
            // 加载数据字典
            let codeList = [
                'orderStatus',
            ]
            this.getThisDict(codeList)

            this.isManager =  this.$route.query.isManager;
            this.loadOrgList();
        },
        methods:{
            loadOrgList() {
                getOrgListByPassId().then((res) => {
                    this.orgColumns = res.data || [];
                });
            },
            openOrgPicker() {
                this.orgSearchKey = '';
                this.showOrgPicker = true;
            },
            onSelectOrg(org) {
                if (org && org.orgId) {
                    this.orgInf = { orgId: org.orgId, orgName: org.orgName };
                } else {
                    this.orgInf = { orgId: '', orgName: '' };
                }
                this.showOrgPicker = false;
                this.orgSearchKey = '';
                this.handleQuery();
            },
            back(){
                if(this.isBackClose){
                    try{
                        window.native.onFinish();
                    }catch (e) {

                    }
                }else{
                    try{
                        window.native.onBack();
                    }catch (e) {
                        this.$router.go(-1)
                    }
                }
            },
            beforeInit() {
                //isManager:this.isManager


                this.params = { page : this.page, limit: this.limit,shopId:this.shopId,orderStatus:this.orderStatus};
                if (this.orgInf.orgId) {
                    this.params.orgId = this.orgInf.orgId;
                }
                this.url = 'order/orderBase/list';
                let query = this.pageInfo;
                for (var key in query){
                    if(query[key]){
                        this.params[key] = query[key]
                    }
                }
                if(!this.$store.state.user.isAdministorRole){
                    this.params.managerPassId = this.$store.state.user.userId;
                }
                return true
            },
            //切换状态
            tabClick(name){
                switch (name) {
                    case '1':
                        this.orderStatus = null;
                        break;
                    case '2':
                        this.orderStatus = 8;
                        break;
                    case '3':
                        this.orderStatus = 2;
                        break;
                    case '4':
                        this.orderStatus = 3;
                        break;
                    case '5':
                        this.orderStatus = 1;
                        break;
                }
                this.handleQuery();
            },

            refundFun(data){
                let _this = this;
                this.$dialog.alert({
                    title: "提示",
                    message: "是否确定要退款？",
                    showCancelButton: true
                })
                    .then(() => {     //点击确认按钮后的调用
                        let detailList = data.productList.map(item=>{
                            let obj = {
                                num: item.productQty,
                                orderProductId:item.productId,
                                salePrice: item.salePrice
                            }
                            return obj
                        })
                        let params = {
                            detailList,
                            orderId: data.orderId
                        }
                        refundOrder(params).then(res=>{
                            if (res.code === 0) {
                                _this.$toast('退款成功');
                                _this.handleQuery();
                            }
                        })
                    })
                    .catch(() => { //点击取消按钮后的调用
                        console.log("cancel")
                    })



            },

            onCopySuccess(){
                this.$toast("复制成功");
            },
            onCopyError(){
                this.$toast("复制失败");
            },

            // 已送达
            deliverOrder(item){
                let _this = this;
                this.$dialog.alert({
                    title: "提示",
                    message: "确定此订单已送达？",
                    showCancelButton: true
                })
                    .then(() => {
                        let params = {
                            orderIds: item.orderId,
                            orderStatus: 1
                        }
                        batchUpdateOrderStatus(params).then(res=>{
                            _this.$toast('操作成功');
                            _this.handleQuery();
                        })
                    })
                    .catch(() => {
                        console.log("cancel")
                    })
            },
        },
        beforeRouteEnter(to, from, next) {
            if (from.name == "sendOrder" || from.name == 'orderDetail') {
                to.meta.isBack = true;
            } else {
                to.meta.isBack = false;
            }
            next();
        },
        activated() {
            if (!this.$route.meta.isBack || this.$store.state.updateOrderList) {
                this.$store.state.updateOrderList = false;
                if(this.hasAlive){
                    this.handleQuery();
                }
            }
            this.$route.meta.isBack = false;
        },
    }
</script>

<style scoped lang="scss">
    .page-state{
        top: .9rem;
    }
    .org-filter-bar {
        padding: 0.16rem 0.24rem;
        border-bottom: 1px solid #f0f0f0;
    }
    .org-filter-trigger {
        display: flex;
        align-items: center;
        height: 0.64rem;
        padding: 0 0.24rem;
        background: #f5f5f5;
        border-radius: 0.32rem;
        font-size: 0.28rem;
    }
    .org-filter-label {
        color: #999;
        flex-shrink: 0;
        margin-right: 0.08rem;
    }
    .org-filter-value {
        flex: 1;
        color: #333;
        min-width: 0;
    }
    .org-filter-icon {
        flex-shrink: 0;
        margin-left: 0.08rem;
        color: #999;
        font-size: 0.24rem;
    }
    .org-picker-popup {
        display: flex;
        flex-direction: column;
        height: 100%;
        background: #fff;
    }
    .org-picker-list {
        flex: 1;
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
    }
    .org-picker-item {
        padding: 0.28rem 0.32rem;
        font-size: 0.3rem;
        color: #333;
        border-bottom: 1px solid #f5f5f5;
        &.active {
            color: $main-color;
            font-weight: 500;
        }
    }
    .org-picker-empty {
        padding: 0.48rem 0.32rem;
        text-align: center;
        font-size: 0.28rem;
        color: #999;
    }
    .order-item{
        margin: .2rem .24rem;
        background: #fff;
        padding: 0 .24rem;
        border-radius: .12rem;
        .product-img{
            width: 1.7rem;
            height: 1.72rem;
            margin-right: .24rem;
        }
        .name{
            height: .8rem;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
        }
    }
    .btn-group{
        padding: .18rem 0;
        display: flex;
        justify-content: flex-end;
        .btn{
            width: 1.64rem;
            height: .56rem;
            text-align: center;
            line-height: .56rem;
            background: #fff;
            border-radius: .12rem;
            font-size: .26rem;
            color: $main-color;
            margin-left: .2rem;
            border: .01rem solid $main-color;
            &.active{
                background: $main-color;
                color: #fff;
            }
        }
    }
    .address-box{
        padding: .24rem 0;
        .alifont{
            font-size: .68rem;
            color: #FF3232;
            margin-right: .1rem;
        }
    }
</style>



// WEBPACK FOOTER //
// orderList.vue?1b1acc12